/* eslint-disable react/require-default-props */
import React, { FC, useState } from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _some from 'lodash/some';
import _map from 'lodash/map';
import { PersonalizationTagTypes } from '@btag/bt-personalization';

import TagField from '../TagField';
import { TAppState } from '../../../../../reducers';
import { ERR_PERSONALIZATION_TAG_GET, ERR_PERSONALIZATION_INVALID_SINGLE_USE } from '../../../../../constants/Errors';
import * as Styled from './styles';
import {
    IPersonalizationSingleUseTag,
    IPersonalizationSingleUseTags,
    IPersonalizationTagDefault,
    IPersonalizationTagsDefault,
} from '../../../../../types/personalization';

interface IProps {
    tags: IPersonalizationTagsDefault | IPersonalizationSingleUseTags;
    hasError: boolean;
    hasInvalidTags: boolean;
    type: PersonalizationTagTypes.DEFAULT | PersonalizationTagTypes.ONETIME;
    tagsInText: string[];
}

const TagList: FC<IProps> = ({ tags, hasError, hasInvalidTags, type, tagsInText }) => {
    const [hasEditOpen, setHasEditOpen] = useState(false);
    const hasAnyTagInText = _some(tags, (_: IPersonalizationTagDefault | IPersonalizationSingleUseTag, name: string) =>
        tagsInText.includes(name)
    );
    const showErrorMsg =
        (type === PersonalizationTagTypes.DEFAULT && hasError) ||
        (type === PersonalizationTagTypes.ONETIME && hasInvalidTags);

    return (
        (hasAnyTagInText || showErrorMsg) && (
            <>
                <Styled.TagTypeTitle>
                    {type === PersonalizationTagTypes.DEFAULT ? 'Directory' : 'Single-Use'} Tags
                </Styled.TagTypeTitle>
                {((!hasError && type === PersonalizationTagTypes.DEFAULT) ||
                    type === PersonalizationTagTypes.ONETIME) &&
                    _map(
                        tags,
                        (tag: IPersonalizationTagDefault | IPersonalizationSingleUseTag, name: string) =>
                            tagsInText.includes(name) && (
                                <TagField
                                    key={`tagfield-${name}`}
                                    tag={{ ...tag, name, type }}
                                    setHasEditOpen={setHasEditOpen}
                                    hasEditOpen={hasEditOpen}
                                />
                            )
                    )}
                {showErrorMsg && (
                    <Styled.TagErrorWrapper>
                        <Styled.TagErrorIcon icon="exclamation-triangle" />
                        <Styled.TagErrorText>
                            {type === PersonalizationTagTypes.DEFAULT
                                ? ERR_PERSONALIZATION_TAG_GET
                                : ERR_PERSONALIZATION_INVALID_SINGLE_USE}
                        </Styled.TagErrorText>
                    </Styled.TagErrorWrapper>
                )}
            </>
        )
    );
};

const mapStateToProps = (state: TAppState) => ({
    hasError: !!_get(state, 'personalization.tag.getTagError', ''),
    hasInvalidTags: !_isEmpty(_get(state, 'personalization.tag.invalidTags', [])),
});

export default connect(mapStateToProps)(TagList);
